export const contactTypeIds: { [key: string]: string } = {
  siteContact: 'e8dbf1f7-46af-44ae-80e4-88362e8b708b',
  officeContact: '089c042b-28ca-463d-8622-ddb81d49866a',
  bccContact: '2bc154f5-e106-4415-bf54-280fb6686aaa',
  companyContact: 'b8a3d528-f9dc-4d45-99da-36fa2915893f',
};
